import moment from "moment";
import { Card } from "shared/components/Card";
import { formatPhone } from "shared/utils";
import { InfoRow } from "views/rent-reporting-id/components/InfoRow";
import { Subscriber } from "views/rent-reporting-id/types";

interface PersonalDetailsProps {
  renter?: Subscriber;
}

export const PersonalDetails = ({ renter }: PersonalDetailsProps) => {
  const getSsnDisplayValue = (ssn?: string) => {
    if (!ssn) return "--";
    return ssn.length === 4 ? `XXX-XX-${ssn}` : ssn;
  };

  return (
    <div className="flex-1 min-w-[350px]">
      <h2 className="mb-2 text-base font-medium text-content-1000">
        Personal Details
      </h2>
      <Card className="min-h-[380px] p-6">
        <InfoRow title="Name" value={renter?.name} />
        <InfoRow
          title="Phone"
          value={renter?.phone ? formatPhone(renter.phone) : "--"}
        />
        <InfoRow title="Email" value={renter?.email} />
        <InfoRow
          title="Date of birth"
          value={renter?.dob ? moment(renter.dob).format("ll") : "--"}
        />
        <InfoRow title="SSN" value={getSsnDisplayValue(renter?.ssn)} />
      </Card>
    </div>
  );
};
